const defaultState = {
	tasks: [],

	codemirror: null,

	taskScriptModal: false,

	scriptParams: {
		taskId: '',
		version: ''
	},

	selectedRows: [],

	searchParams: {
		taskId: ''
	},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
